import './style.sass';

import clsx from 'clsx';
import FullWrapper from 'core/FullWrapper';
import { sanitize } from 'isomorphic-dompurify';

type ProjectType = {
    projectTitle: string;
    projectResults: ProjectResultType[];
};
type ProjectResultType = {
    title: string;
    description: string;
};

type CommonResultType = {
    id: string;
    text: string;
};
type ResultsPropsType = {
    resultsList: ProjectType[];
    commonResultsList: CommonResultType[];
};
const Results = ({ resultsList, commonResultsList }: ResultsPropsType) => {
    return (
        <div className="moscowExchange-results">
            <FullWrapper isMargin={false}>
                <div className="moscowExchange-resultsInner">
                    <div className="moscowExchange-resultsLeft">
                        <div className="moscowExchange-resultsTitle">Результаты</div>
                        <div className="moscowExchange-resultsParagraf">
                            Несмотря на&nbsp;высокую конкурентность по&nbsp;продвигаемым запросам
                            со&nbsp;стороны других финансовых агрегаторов и&nbsp;собственных сайтов
                            крупных банков, уже за&nbsp;первые пять месяцев продвижения добились
                            уверенного роста трафика.
                        </div>
                        <div
                            className={clsx(
                                'moscowExchange-resultsParagraf',
                                'moscowExchange-resultsParagrafMargin'
                            )}
                        >
                            В сравнении с данными на момент подключения нашей команды трафик вырос в
                            4 раза в приоритетных направлениях.
                        </div>
                        {resultsList.map(item => {
                            return (
                                <div key={item.projectTitle}>
                                    <div
                                        dangerouslySetInnerHTML={{
                                            __html: sanitize(item.projectTitle),
                                        }}
                                        className="moscowExchange-projectTitle"
                                    ></div>
                                    <div className="moscowExchange-resultsList">
                                        {item.projectResults.map(({ title, description }) => (
                                            <div key={title} className="moscowExchange-resultsItem">
                                                <div
                                                    dangerouslySetInnerHTML={{
                                                        __html: sanitize(title),
                                                    }}
                                                    className="moscowExchange-resultsText"
                                                ></div>
                                                <div
                                                    dangerouslySetInnerHTML={{
                                                        __html: sanitize(description),
                                                    }}
                                                    className="moscowExchange-resultsDescription"
                                                ></div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            );
                        })}

                        <div className="moscowExchange-resultsInner">
                            <div>
                                {commonResultsList.map(item => {
                                    return (
                                        <ul key={item.id} className="moscowExchange-list">
                                            <li
                                                dangerouslySetInnerHTML={{
                                                    __html: sanitize(item.text),
                                                }}
                                            ></li>
                                        </ul>
                                    );
                                })}
                            </div>
                        </div>

                        <div className="moscowExchange-resultsParagraf">
                            Команда &laquo;Вебпрактик&raquo; работает как центр экспертизы
                            и&nbsp;оперативно корректирует стратегии продвижения под бизнес-запросы
                            клиента, что и&nbsp;продемонстрировали на&nbsp;этом проекте.
                            На&nbsp;нашей стороне хорошее качественное SEO, а&nbsp;клиент отвечает
                            за&nbsp;внедрение рекомендаций.
                        </div>
                    </div>
                </div>
            </FullWrapper>
        </div>
    );
};

export default Results;
